import React from 'react'
import AddHub from './AddHub'

const Edit = (props) => {
    return (<AddHub  {...props}
        showEdit={true} />)
}

export default Edit